import { observer } from "mobx-react";
import React, { useMemo } from "react";
import { useInRouterContext } from "react-router";

import { useAppLeftBarItemStyles } from "./AppLeftBarItem.styles";
import { AppLeftBarItemProps } from "./AppLeftBarItem.types";
import { AppLeftBarItemInRoute } from "./AppLeftBarItemInRoute";

const AppLeftBarItemBase = (props: AppLeftBarItemProps) => {
    const { item, matchedItem, onDismiss, active } = props;

    const isInRouter = useInRouterContext();

    const selected = useMemo(() => matchedItem.itemKey === item.displayName || !!active, [item.displayName, matchedItem.itemKey, active]);

    const classNames = useAppLeftBarItemStyles({ selected: selected });

    if (!isInRouter) {
        return (
            <div className={classNames.root} aria-label={item.description ? `${item.displayName}, ${item.description}` : item.displayName}>
                {item.regularIcon && <item.regularIcon className={classNames.leftBarIcon} />}
                <div className={classNames.leftBarTitle}>{item.displayName}</div>
            </div>
        );
    } else {
        return <AppLeftBarItemInRoute item={item} matchedItem={matchedItem} onDismiss={onDismiss} />;
    }
};

export const AppLeftBarItem = observer(AppLeftBarItemBase);
